webpackJsonp([39303389681148],{

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styles2 = __webpack_require__(606);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Story = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      section = props.section,
	      key = props.key;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: { width: '100%' }, key: key },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          'div',
	          { className: classes.section, style: { width: '100%' } },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 40 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 12 },
	              section.image && section.image.src.length > 0 && _react2.default.createElement('img', {
	                src: section.image.src,
	                alt: section.image.alt,
	                className: classes.sectionImage
	              })
	            )
	          )
	        )
	      )
	    ),
	    section.contents.map(function (content, index) {
	      return _react2.default.createElement(StoryContent, { key: key, content: content, classes: classes });
	    })
	  );
	});
	
	var StoryContent = function StoryContent(_ref) {
	  var content = _ref.content,
	      classes = _ref.classes,
	      key = _ref.key;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { width: '100%' }, key: key },
	    content.image && _react2.default.createElement(Teaser, { image: content.image }),
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          'div',
	          { className: classes.section, style: { width: '100%' } },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 40 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 12 },
	              _react2.default.createElement(
	                _Typography2.default,
	                { gutterBottom: true, variant: 'title' },
	                content.title.text
	              ),
	              _react2.default.createElement(
	                _Typography2.default,
	                { gutterBottom: true, variant: 'subheading' },
	                content.subtitle.text
	              ),
	              _react2.default.createElement('div', {
	                dangerouslySetInnerHTML: {
	                  __html: content.text && content.text.html
	                },
	                className: classes.text
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var Teaser = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      image = props.image;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.teaser, style: { width: '100%' } },
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, spacing: 0 },
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12 },
	        _react2.default.createElement('div', {
	          style: {
	            background: 'url(' + image.src + ')',
	            backgroundPosition: 'center',
	            backgroundSize: 'cover',
	            height: '50vh'
	          }
	        })
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Story);
	module.exports = exports['default'];

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  return {
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    sectionImage: {
	      width: '100%',
	      maxWidth: 1024,
	      marginBottom: theme.spacing.unit * 4
	    },
	    teaser: {
	      height: '100%',
	      minHeight: '60vh',
	      // backgroundImage: 'linear-gradient(to right top, #051937, #004d7a, #008793, #00bf72, #a8eb12)',
	      textAlign: 'left',
	      display: 'flex',
	      alignItems: 'center'
	    },
	    text: _extends({}, (0, _mixins.RichText)(theme))
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _gradient = __webpack_require__(83);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _identity = __webpack_require__(140);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _styles2 = __webpack_require__(608);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Strap = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      uid = props.uid,
	      title = props.title,
	      subtitle = props.subtitle,
	      published = props.published;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.strap },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true, spacing: 40 },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12 },
	            _react2.default.createElement(
	              _Typography2.default,
	              { className: classes.subtitle, gutterBottom: true },
	              title.text
	            ),
	            _react2.default.createElement(
	              _Typography2.default,
	              { className: classes.title, gutterBottom: true },
	              _react2.default.createElement(_gradient2.default, {
	                text: subtitle.text,
	                fromColor: _identity2.default[uid].from,
	                toColor: _identity2.default[uid].to,
	                direction: 'left'
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Strap);
	module.exports = exports['default'];

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  var _subtitle, _title;
	
	  return {
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    strap: {
	      marginTop: theme.spacing.unit * 10,
	      height: '50vh'
	    },
	    subtitle: (_subtitle = {
	      fontSize: theme.typography.body2.fontSize,
	      textTransform: 'uppercase'
	    }, _subtitle[theme.breakpoints.down('sm')] = {
	      fontSize: theme.typography.caption.fontSize
	    }, _subtitle),
	    title: (_title = {
	      fontSize: theme.typography.display1.fontSize,
	      textTransform: 'uppercase',
	      fontWeight: 800,
	      lineHeight: 1
	    }, _title[theme.breakpoints.down('sm')] = {
	      fontSize: theme.typography.headline.fontSize
	    }, _title),
	    share: {
	      float: 'right'
	    }
	
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _site = __webpack_require__(43);
	
	var _site2 = _interopRequireDefault(_site);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _banner = __webpack_require__(67);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _strap = __webpack_require__(607);
	
	var _strap2 = _interopRequireDefault(_strap);
	
	var _quote = __webpack_require__(68);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _story = __webpack_require__(605);
	
	var _story2 = _interopRequireDefault(_story);
	
	var _relatedcontent = __webpack_require__(165);
	
	var _relatedcontent2 = _interopRequireDefault(_relatedcontent);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _constants = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Service = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes;
	
	  var metadata = (0, _mapper.mapMetaData)(props.data.service);
	  var service = (0, _mapper.mapService)(props.data.service);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_metadata2.default, { data: metadata }),
	    _react2.default.createElement(_banner2.default, {
	      uid: 'services_' + service.uid,
	      title: service.service_headline,
	      subtitle: service.service_subtitle
	      // image={service.banner}
	    }),
	    _react2.default.createElement('img', {
	      src: service.banner.src,
	      style: { width: 108, height: 108, marginTop: -116, marginLeft: '65%' }
	    }),
	    _react2.default.createElement(_strap2.default, {
	      uid: service.uid,
	      title: service.lead_title,
	      subtitle: service.lead_summary,
	      path: props.location.pathname
	    }),
	    service.contents && service.contents.map(function (content, index) {
	      var _React$createElement, _React$createElement2;
	
	      if (content == null) {
	        // FIXME: Optional chaining?
	        return;
	      }
	      switch (content.type) {
	        case _constants.CONTENTTYPES.section:
	          return _react2.default.createElement(_story2.default, (_React$createElement = { key: index, section: content }, _React$createElement['key'] = index, _React$createElement));
	        case _constants.CONTENTTYPES.quote:
	          return _react2.default.createElement(_quote2.default, (_React$createElement2 = { key: index, quote: content }, _React$createElement2['key'] = index, _React$createElement2));
	        case _constants.CONTENTTYPES.contentLink:
	          return _react2.default.createElement(
	            'div',
	            { className: classes.margins, style: { marginBottom: 60 }, key: index },
	            _react2.default.createElement(_relatedcontent2.default, {
	              service: service.uid,
	              key: index,
	              content: content.content,
	              noBackground: true
	            })
	          );
	      }
	    }),
	    _react2.default.createElement(_footer2.default, { policies: props.data.policies.edges })
	  );
	});
	
	exports.default = Service;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var identity = {
	  logo: {
	    height: 40,
	    width: 100,
	    backgroundPosition: 'center center',
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'contain'
	  },
	  develop: {
	    navText: '#A2C3B7',
	    // backgroundGradient: 'linear-gradient(110deg, #64CDB4 0%, #53ABAF 55%, #4FA0AA 56%, #313C5E 100%)',
	    backgroundGradient: 'linear-gradient(to right top, #41495e, #4b677c, #578796, #6ca7a8, #8fc7b5)',
	    from: '#41495e',
	    to: '#8fc7b5',
	    offset: '#ffffff'
	  },
	  devops: {
	    navText: '#C45A5E',
	    // backgroundGradient: 'linear-gradient(110deg, #FDBCDD 0%, #E24E74 55%, #DA3F68 56%, #D60424 100%)',
	    backgroundGradient: 'linear-gradient(to right top, #ea3b4c, #e3475b, #db5268, #d15c73, #c6667c)',
	    from: '#ea3b4c',
	    to: '#c6667c',
	    offset: '#ffffff'
	  },
	  dynamics_365: {
	    navText: '#7760E3',
	    // backgroundGradient: 'linear-gradient(110deg, #50047F 0%, #7B2AAE 55%, #7126A2 56%, #912D99 100%)',
	    backgroundGradient: 'linear-gradient(to right top, #3e2772, #4f3291, #613eb1, #734ad3, #8656f5)',
	    from: '#3e2772',
	    to: '#8656f5',
	    offset: '#ffffff'
	  },
	  datascience: {
	    navText: '#38CCF1',
	    // backgroundGradient: 'linear-gradient(110deg, #50047F 0%, #7B2AAE 55%, #7126A2 56%, #912D99 100%)',
	    backgroundGradient: 'linear-gradient(to right top, #1659cb, #007ce0, #009beb, #00b8f0, #4ed4f2)',
	    from: '#7FDFF7',
	    to: '#145DCD',
	    offset: '#ffffff'
	  },
	  taas: {
	    navText: '#C4BE5A'
	  },
	  fixed: {
	    navText: '#E38E60'
	  },
	
	  studies: {
	    backgroundGradient:
	    // ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
	    'linear-gradient(to right top, #b8557b, #ba398b, #ae1da6, #8c17c9, #072ff0)',
	    offset: '#ffffff'
	  },
	  blog: {
	    backgroundGradient: ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
	    offset: '#ffffff'
	  },
	  careers: {
	    backgroundGradient: ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
	    offset: '#ffffff'
	  },
	  about: {
	    backgroundGradient: ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
	    offset: '#ffffff'
	  },
	  contact: {
	    backgroundGradient: ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
	    offset: '#ffffff'
	  }
	};
	
	exports.default = identity;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-services-service-js-a0e6252188071b58fd47.js